import { render, staticRenderFns } from "./matchingResults.vue?vue&type=template&id=504727f9&scoped=true"
import script from "./matchingResults.vue?vue&type=script&lang=js"
export * from "./matchingResults.vue?vue&type=script&lang=js"
import style0 from "./matchingResults.vue?vue&type=style&index=0&id=504727f9&prod&lang=css"
import style1 from "./matchingResults.vue?vue&type=style&index=1&id=504727f9&prod&scoped=true&lang=css"
import style2 from "./matchingResults.vue?vue&type=style&index=2&id=504727f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504727f9",
  null
  
)

export default component.exports